$(document).ready(function () {
  
  window.menuVue = new Vue({
    el: '#top_header',
  });

  
  new Swiper('.swiper-main', {
    slidesPerView: 1,
    loop: false,
    autoplay: {
      delay: 3000,
    },
    spaceBetween: 0,

    // If we need pagination
    pagination: {
      el: '.swiper-pagination',
      clickable: true,
    },
    breakpoints: {
      640: {
        slidesPerView: 1,
        spaceBetween: 0,
      },
      768: {
        slidesPerView: 1,
        spaceBetween: 0,
      },
      1024: {
        slidesPerView: 1,
        spaceBetween: 0,
        autoplay: {
          delay: 3000,
        },
      },
    },
  });
  
});

